import { ACCENT_BLUE, NOPING_GREEN } from '../constants';

const PARTICLE_COUNT = 40;

export function ParticleField() {
  return (
    <div className='pointer-events-none absolute inset-0 overflow-hidden' aria-hidden='true'>
      {Array.from({ length: PARTICLE_COUNT }).map((_, i) => {
        const size = 1 + ((i * 1.7) % 3);
        const left = (i * 37) % 100;
        const top = (i * 53) % 100;
        const delay = (i * 0.7) % 10;
        const duration = 10 + ((i * 1.3) % 15);
        const mod = i % 4;
        const colorMap: Record<number, string> = { 0: NOPING_GREEN, 1: ACCENT_BLUE };
        const color = colorMap[mod] ?? 'rgba(255,255,255,0.4)';
        const opacity = 0.15 + ((i * 0.03) % 0.2);

        return (
          <div
            key={i}
            className='animate-eu-particle-drift absolute rounded-full'
            style={{
              width: `${size}px`,
              height: `${size}px`,
              left: `${left}%`,
              top: `${top}%`,
              background: color,
              opacity,
              animationDuration: `${duration}s`,
              animationDelay: `${delay}s`,
            }}
          />
        );
      })}
      <style>{`
        @keyframes euParticleDrift {
          0%, 100% { transform: translate(0, 0) scale(1); }
          25% { transform: translate(15px, -20px) scale(1.3); }
          50% { transform: translate(-10px, 10px) scale(0.8); }
          75% { transform: translate(20px, 15px) scale(1.1); }
        }
        .animate-eu-particle-drift {
          animation: euParticleDrift ease-in-out infinite;
        }
      `}</style>
    </div>
  );
}
